import "./styles.scss"

import React from "react"
import { motion } from "framer-motion"

import { useLocale } from "context/locale"

import Button from "components/Button"

import { fadeAnimation } from "utils"

const Baner = ({ data }) => {
  const { t } = useLocale()

  return (
    <section className="careers-baner">
      <motion.div className="container" {...fadeAnimation}>
        <h2>{data?.careersBannerHeading}</h2>
        <div dangerouslySetInnerHTML={{ __html: data?.careersBannerText }} />
        <Button
          className="button--text-dark"
          to={t("/company/careers-apply-now/")}
        >
          {t("Apply now")}
        </Button>
      </motion.div>
    </section>
  )
}

export default Baner
